import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _PatientWebRequestAccessTokenComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import ControlTower from 'wise-control-tower';
import { task } from 'ember-concurrency';
import { eq } from 'ember-truth-helpers';
import WrForm from 'ember-wiser/components/wr/form';
import { Changeset } from 'ember-changeset';
import perform from 'ember-concurrency/helpers/perform';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
let PatientWebRequestAccessTokenComponent = (_class = (_PatientWebRequestAccessTokenComponent = class PatientWebRequestAccessTokenComponent extends Component {
  constructor(...args) {
    super(...args);
    // how does the patient want to receive the login link
    _initializerDefineProperty(this, "sendBy", _descriptor, this);
    // The successful submit server response
    _initializerDefineProperty(this, "successfulResponse", _descriptor2, this);
    // The error returned by the submit call, if any
    _initializerDefineProperty(this, "error", _descriptor3, this);
    _initializerDefineProperty(this, "requestManager", _descriptor4, this);
    _defineProperty(this, "model", Changeset({
      sendTo: ''
    }));
    _defineProperty(this, "submitTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        this._reset();
        // Remove any whitespace within phone or email value
        const inputValue1 = this.sendTo.replace(/\s/g, '');
        //if value is composed only of numbers or starting by + and followed by numbers (handle +33 phone numbers)
        if (inputValue1.match(/^\+?(\d)+$/)) {
          this.sendBy = 'SMS';
        } else {
          this.sendBy = 'email';
        }
        const data1 = JSON.stringify({
          send_by: this.sendBy,
          send_to: this.sendTo
        });
        try {
          const {
            response: response1,
            content: content1
          } = yield this.requestManager.request({
            url: '/api/v1/patient_token',
            method: 'POST',
            body: data1
          });
          if (!response1.ok) throw response1;
          this.successfulResponse = content1;
        } catch (e1) {
          this.error = e1;
          /* Only the 404 error is valid for display. It means the patient has not been found. */
          if (e1.status == 404) return;
          ControlTower.captureException(e1);
        }
      }
    }), null, "submitTask", null));
  }
  get sendTo() {
    return this.model.sendTo;
  }
  _reset() {
    this.successfulResponse = undefined;
    this.error = undefined;
  }
}, setComponentTemplate(precompileTemplate("\n    {{#if this.successfulResponse}}\n      <div class=\"ui positive message\">\n        Un lien de connexion va vous \xEAtre envoy\xE9 par\n        {{this.sendBy}}.\n      </div>\n    {{else}}\n      {{#if this.error}}\n        <div class=\"ui negative message\">\n          {{#if (eq this.error.status 404)}}\n            Aucun compte n'existe avec\n            {{if (eq this.sendBy \"email\") \"cet email\" \"ce num\xE9ro de t\xE9l\xE9phone\"}}.\n          {{else}}\n            {{!-- Any other error --}}\n            Nous sommes d\xE9sol\xE9s, une erreur est survenue.\n          {{/if}}\n        </div>\n      {{/if}}\n\n      <WrForm @data={{this.model}} @onSubmit={{perform this.submitTask}} class=\"flex w-full max-w-[355px] flex-col items-center gap-6\" as |form|>\n        {{#unless this.successfulResponse}}\n          <form.Input @name=\"sendTo\" aria-label=\"Votre e-mail ou num\xE9ro de t\xE9l\xE9phone\" type=\"text\" required={{true}} placeholder=\"Votre e-mail ou num\xE9ro de t\xE9l\xE9phone\" data-test-login=\"email-or-phone\" />\n        {{/unless}}\n\n        <form.SubmitButton @icon=\"ArrowRight\">\n          Recevoir le lien\n        </form.SubmitButton>\n      </WrForm>\n    {{/if}}\n  ", {
  strictMode: true,
  scope: () => ({
    eq,
    WrForm,
    perform
  })
}), _PatientWebRequestAccessTokenComponent), _PatientWebRequestAccessTokenComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "sendBy", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "successfulResponse", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "error", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "requestManager", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { PatientWebRequestAccessTokenComponent as default };